/**
* DevExpress Analytics (query-builder\dataSource\_dbSchema.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function deserializeToCollection(model, createItem, collection) {
    var collection = collection || [];
    if (model) {
        model.forEach(function (value) {
            collection.push(createItem(value));
        });
    }
    return collection;
}
exports.deserializeToCollection = deserializeToCollection;
